export default "__VITE_ASSET__BLGnjxy7__"